export default "__VITE_ASSET__63338d30__"